/*获取地理位置信息*/

export default function getLocation(success,fail){
  if (navigator.geolocation){
    navigator.geolocation.getCurrentPosition(success,fail);
  }else{
    file();
  }
}

function showError(error){
  switch(error.code) {
    case error.PERMISSION_DENIED:
      alert("定位失败,用户拒绝请求地理定位");
      break;
    case error.POSITION_UNAVAILABLE:
      alert("定位失败,位置信息是不可用");
      break;
    case error.TIMEOUT:
      alert("定位失败,请求获取用户位置超时");
      break;
    case error.UNKNOWN_ERROR:
      alert("定位失败,定位系统失效");
      break;
  }
}

function showPosition(position){
  var lat = position.coords.latitude; //纬度
  var lag = position.coords.longitude; //经度
  console.log('纬度:'+lat+',经度:'+lag);
}
